import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleSelectData } from 'src/types';
import { availableRoles } from 'src/types/public/public-data-model.types';

export const useRolesMapperSelect = () => {
  const { t } = useTranslation();
  const rolesMapperSelect: SimpleSelectData = useMemo(() => {
    return availableRoles.map((role) => {
      return {
        value: role,
        label: t(`${role}`),
      };
    });
  }, [t]);

  return {
    rolesMapperSelect,
  };
};
